import emailIcon from '@iconify/icons-carbon/email';
import locationIcon from '@iconify/icons-carbon/location';
import type { Link, LinkProps, Typography, TypographyProps } from '@mui/material';
import { Box, Card, CardContent, Stack } from '@mui/material';
import { alpha } from '@mui/material/styles';

import { cssStyles } from '@larvitu/shared/mui/ui-components';
import { IconifyIcon } from '@larvitu/shared/react/components/ui-iconify-icon';

import { ContactHookForm } from './form/ContactHookForm';
import type { FC, ReactElement } from 'react';

export interface ConsultingSectionProps {
  // header: ReactNode;
  // header: ComponentType<typeof Typography>;
  header: ReactElement<TypographyProps, typeof Typography>;
  // email: ComponentType<typeof links>;
  email: ReactElement<LinkProps, typeof Link>;
  // address: ComponentType<TypographyProps>;
  address: ReactElement<TypographyProps, typeof Typography>;
}

export const ConsultingSection: FC<ConsultingSectionProps> = ({
  header,
  email,
  address,
}) => (
  <Box
    display="flex"
    flexDirection={{ xs: 'column', md: 'row' }}
    alignItems="stretch"
    py={2}
  >
    <Box
      borderRadius="0 0.5rem 0.5rem 0"
      width={{ xs: '100%', md: 'calc(50% + ((1200px * 0.5) - 570px))' }}
      display="flex"
      flexDirection={{ sx: 'row', md: 'row-reverse' }}
      justifyContent={{ xs: 'center', md: 'unset' }}
      sx={(theme) => ({
        ...cssStyles( theme ).bgImage( {
          direction: 'right',
          url: '/assets/images/AdobeStock_286053032.jpeg',
          startColor: `${alpha( theme.palette.grey[100], 0.1 )} 0%`,
          endColor: `${alpha( theme.palette.grey[100], 0.9 )} 60%`,
        } ),
        boxShadow: 'inset -10px 20px 50px -26px #aaa',
        backgroundAttachment: 'fixed',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      })}
    >
      <Box
        maxWidth={600}
      >
        <Card
          sx={{
            p: 4,
            m: 2.5,
            backgroundColor: 'rgba(255,255,255, 0.8)',
          }}
        >
          {header}
          <Stack
            spacing={1}
            direction="row"
            alignItems="center"
            mb={2}
            sx={{
              color: 'common.black',
            }}
          >
            <IconifyIcon
              icon={emailIcon}
              width={24}
              height={24}
            />
            {email}
          </Stack>

          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            mb={8}
            sx={{ color: 'common.black' }}
          >
            <IconifyIcon
              icon={locationIcon}
              width={24}
              height={24}
            />
            {address}
          </Stack>
        </Card>
      </Box>
    </Box>
    <Box display="flex" justifyContent="center">
      <Card
        variant="outlined"
        sx={{
          my: { xs: 8, md: 0 },
          mx: 2,
          maxWidth: 570,
        }}
      >
        <CardContent>
          <ContactHookForm />
        </CardContent>
      </Card>
    </Box>
    <Box
      width="calc(50% -  570px)"
      borderRadius="0.5rem 0 0 0.5rem"
      sx={(theme) => ({
        ...cssStyles( theme ).bgImage( {
          direction: 'right',
          url: '/assets/images/AdobeStock_286053032.jpeg',
          startColor: `${alpha( theme.palette.grey[300], 0 )} 0%`,
          endColor: `${alpha( theme.palette.grey[300], 0.6 )} 50%`,
        } ),
        boxShadow: 'inset -10px 20px 50px -26px #aaa',
        backgroundAttachment: 'fixed',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      })}
    />
  </Box>
);
